import React from 'react';
import RedFlags from './redFlags';
const MoreInfo = () => {
    return (
       <RedFlags />
    );
};

export default MoreInfo;